import { getAllHeadersWithAuth, handleError, handleResponse } from '_helpers';

export const releaseService = {
  getReleaseMetadata,
  updateReleaseArtifacts,
  getAllReleases,
  getProdManifest,
  getEnvInfo,
};

function getReleaseMetadata(releaseVersion) {
  let headers = getAllHeadersWithAuth();
  const requestOptions = {
    method: 'GET',
    headers,
  };

  return fetch(
    process.env.REACT_APP_DASHBOARD_API_BASE_URL + '/release/' + releaseVersion + '/metadata',
    requestOptions,
  )
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}

function updateReleaseArtifacts(updateReleaseArtifactsRequest, releaseId) {
  let headers = getAllHeadersWithAuth();
  const requestOptions = {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(updateReleaseArtifactsRequest),
  };
  return fetch(
    process.env.REACT_APP_DASHBOARD_API_BASE_URL + '/release/' + releaseId + '/artifacts',
    requestOptions,
  )
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}

function getProdManifest(releaseVersion) {
  let headers = getAllHeadersWithAuth();

  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(process.env.REACT_APP_DASHBOARD_API_BASE_URL + "/release/" + releaseVersion + "/manifest", requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}

function getAllReleases() {
  let headers = getAllHeadersWithAuth();

  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(process.env.REACT_APP_DASHBOARD_API_BASE_URL + "/release", requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}

function getEnvInfo(env) {
  let headers = getAllHeadersWithAuth();

  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(process.env.REACT_APP_DASHBOARD_API_BASE_URL + "/manifest/" + env , requestOptions)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}